<template>
  <div v-bind="$attrs">
    <v-img :src="src" :alt="alt" :width="width"></v-img>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from "vue"

  export default defineComponent({
    inheritAttrs: false,
    props: {
      src: {
        type: String,
        default: "",
        required: true,
      },
      alt: {
        type: String,
        default: "",
      },
      width: {
        type: String,
        default: "",
      },
    },
  })
</script>
